export default "__VITE_ASSET__DQAzfMQZ__"